module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('spinner') : _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "pagination-options": {
        'enabled': true
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field === 'name') ? _c('div', {
          staticClass: "highlight"
        }, [_c('div', {
          staticClass: "warning"
        }), _vm._v("\n        " + _vm._s(props.row.name) + "\n      ")]) : (props.column.field === 'type') ? _c('span', {
          staticClass: "capitalize"
        }, [_vm._v(_vm._s(props.row.type))]) : (props.column.field === 'publish') ? _c('span', [_c('span', {
          staticClass: "label label-sm",
          class: [props.row.publish === 'Published' ? 'label-warning' : 'label-danger']
        }, [_vm._v("\n          " + _vm._s(props.row.publish) + "\n        ")])]) : (props.column.field === 'actions') ? [_c('div', {
          staticClass: "last-dropdown"
        }, [_c('actions-menu', [_c('actions-menu-item', {
          attrs: {
            "title": "Edit",
            "icon": "fa-edit",
            "to": {
              name: 'Form Builder Edit',
              params: {
                id: props.row.id
              }
            }
          }
        }), _vm._v(" "), (!_vm.isTemplate) ? _c('actions-menu-item', {
          attrs: {
            "title": "Export PDF",
            "icon": "fa-file-pdf-o"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.exportPDF(props.row.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (!_vm.isTemplate) ? _c('actions-menu-item', {
          attrs: {
            "title": "Duplicate",
            "icon": "fa-files-o"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.duplicateForm(props.row.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('actions-menu-item', {
          attrs: {
            "title": "Remove",
            "icon": "fa-trash"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeForm(props.row.id)
            }
          }
        }), _vm._v(" "), (_vm.showShareUrl) ? _c('actions-menu-item', {
          attrs: {
            "title": "Copy link to the form",
            "icon": "fa-link"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.copyLink(props.row.shareUrl, $event.target)
            }
          }
        }) : _vm._e()], 1)], 1)] : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n      No forms available.\n    ")])]), _vm._v(" "), (_vm.showDuplicateFormModal) ? _c('duplicate-form-modal', {
    attrs: {
      "duplicateFormId": _vm.formId
    },
    on: {
      "hide": function($event) {
        _vm.showDuplicateFormModal = false
      },
      "duplicate-success": _vm.formDuplicated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRemoveFormModal) ? _c('remove-form-modal', {
    attrs: {
      "form-id": _vm.formId
    },
    on: {
      "form-removed": function($event) {
        return _vm.$emit('form-removed', _vm.formId)
      },
      "display": function($event) {
        _vm.showRemoveFormModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38d4bb97","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/indexes/BaseFormIndex.vue
// module id = 1609
// module chunks = 1